import { AppUser } from '@modules/company-manager/users/domain';
import { Request } from '@modules/regular-user/requests/domain';
import { CacheableState } from '@utils/cacheable-state';

export interface ApprovesState {
  allApproves: CacheableState<Array<any>>;
  exportApproves: CacheableState<Array<any>>;
  requestToApprove: CacheableState<Request>;
  approveARequest: CacheableState<boolean>;
  denyARequest: CacheableState<boolean>;
  approvers: CacheableState<Array<AppUser>>;
  myApproves: CacheableState<Array<any>>;
  approvalsCount: CacheableState<number>;
  requestsToApprove: CacheableState<Array<Request>>;
  approversByCompany: CacheableState<Array<any>>;
}

export function approvesInitialState(): ApprovesState {
  return {
    allApproves: initialDataSubState().allApproves,
    exportApproves: initialDataSubState().exportApproves,
    requestToApprove: initialDataSubState().requestToApprove,
    approveARequest: initialDataSubState().approveARequest,
    denyARequest: initialDataSubState().denyARequest,
    approvers: initialDataSubState().approvers,
    myApproves: initialDataSubState().myApproves,
    approvalsCount: initialDataSubState().approvalsCount,
    requestsToApprove: initialDataSubState().requestsToApprove,
    approversByCompany: initialDataSubState().approversByCompany,
  };
}
export function initialDataSubState(): ApprovesState {
  return {
    allApproves: new CacheableState(),
    exportApproves: new CacheableState(),
    requestToApprove: new CacheableState(),
    approveARequest: new CacheableState(),
    denyARequest: new CacheableState(),
    approvers: new CacheableState(),
    myApproves: new CacheableState(),
    approvalsCount: new CacheableState(),
    requestsToApprove: new CacheableState(),
    approversByCompany: new CacheableState(),
  };
}
